import { Link as RouterLink } from "react-router";
import MuiIconButton, { IconButtonProps } from "@mui/material/IconButton";

import { TestProps } from "shared/types";
import { isInternalHref } from "shared/utils";

import Tooltip from "features/components/Tooltip";

interface Props extends IconButtonProps, TestProps {
  tooltip?: string;
  // Renders the button as the link itself. A button inside an anchor is neither valid nor one focus stop.
  href?: string;
}

const IconButton = ({ tooltip, testId, href, ...props }: Props) => {
  const button = (
    <MuiIconButton
      {...(href && isInternalHref(href)
        ? { component: RouterLink, to: href }
        : { href })}
      data-testid={testId}
      {...props}
    />
  );

  return tooltip ? <Tooltip title={tooltip}>{button}</Tooltip> : button;
};

export default IconButton;
